import { filter, forEach, map } from 'lodash-es';

/**
 * Filters the accommodation notifications.
 *
 * @param state
 * @returns {Array}
 */
export const getAccommodationNotificationsFiltered = (state) => {
    const notifications = (state.notifications) ? state.notifications.items : [];
    const site = state.notifications.filters.site;
    const accommodation = state.notifications.filters.accommodation;
    const predicate = state.notifications.filters.predicate;

    return filter(notifications, (notification) => {
        const filterSite = (site) ? site === notification.site : true;
        const filterAcc = (accommodation) ? notification.accommodation === accommodation : true;
        const filterStatus = (predicate) ? notification.status === predicate : true;
        return filterSite && filterAcc && filterStatus;
    });
};

/**
 * Get the list of accommodation notifications filtered and paginated.
 *
 * @param state
 * @returns {*[]}
 */
export const getAccommodationNotificationsFilteredPaginated = (state) => {
    const page = state.notifications.page;
    const limit = state.notifications.limit;
    return getAccommodationNotificationsFiltered(state).slice((page * limit) - limit, page * limit);
};

/**
 * Get the filters of sites and accommodations.
 *
 * @param state
 * @returns {{sites: Array, accommodations: Array}}
 */
export const getAccommodationNotificationFilters = (state) => {
    const notifications = (state.notifications) ? state.notifications.items : [];
    const sites = [];
    const accommodations = [];

    forEach(notifications, (notification) => {
        if(sites.indexOf(notification.site) === -1) sites.push(notification.site)
        if(accommodations.indexOf(notification.accommodation) === -1) accommodations.push(notification.accommodation)
    });

    return {
        sites: sites,
        accommodations: accommodations
    }
};

/**
 * Returns the max page count of the accommodation notifications filtered.
 *
 * @param state
 * @returns {number}
 */
export const accommodationNotificationsFilteredMaxPages = (state) => {
    const limit = state.notifications.limit;
    return Math.ceil(getAccommodationNotificationsFiltered(state).length / limit);
};

/**
 * Extracts the accommodation key value object.
 *
 * @param state
 * @returns {Array}
 */
export const getAccommodationsKeyValueObject = (state) => {
    const items = (state.availability.items) ? state.availability.items.accommodations : [];
    return map(items, (item, index) => {
        return{value: index, name: item.accommodationName};
    });
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js